/** Closed `entry_point` property values for catalog events. */
export const ENTRY_POINT_UI_CLICK = 'ui_click';
export const ENTRY_POINT_DIALOG_CLOSE = 'dialog_close';
